import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-center"
};
const _hoisted_2 = {
  class: "text-body-2 text-grey"
};
const _hoisted_3 = ["src"];
import { ref, onMounted, watch } from 'vue';
import { useInsightsDashboardStore } from '@/modules/insights/useInsightsDashboardStore';
export default {
  __name: 'MetabaseDashboard',
  props: {
    dashboardId: {
      type: String,
      required: true
    },
    alerts: {
      type: Object,
      required: false
    },
    minHeight: {
      type: String,
      default: '400px'
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const insightsDashboardStore = useInsightsDashboardStore();
    const dashboardLink = ref('');
    const loading = ref(true);
    const error = ref(null);
    const loadDashboard = async () => {
      if (!props.dashboardId) {
        error.value = 'Dashboard ID is required';
        loading.value = false;
        return;
      }
      try {
        loading.value = true;
        error.value = null;
        const link = await insightsDashboardStore.getDashboardLink(props.dashboardId, props.filters);
        dashboardLink.value = link;
      } catch (err) {
        error.value = err?.response?.data?.message || err.message || 'An error occurred while loading the dashboard';
      } finally {
        loading.value = false;
      }
    };
    watch(() => props.dashboardId, () => {
      loadDashboard();
    }, {
      immediate: true
    });
    watch(() => props.filters, () => {
      loadDashboard();
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        fluid: "",
        class: "pa-0 fill-height"
      }, {
        default: _withCtx(() => [loading.value ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "fill-height w-full",
          elevation: "0"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, {
            class: "d-flex justify-center align-center fill-height"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "64"
            })]),
            _: 1
          })]),
          _: 1
        })) : error.value ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "fill-height w-full",
          elevation: "0"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, {
            class: "d-flex justify-center align-center fill-height"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_icon, {
              size: "64",
              color: "error",
              class: "mb-4"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-alert-circle", -1)]))]),
              _: 1
            }), _cache[1] || (_cache[1] = _createElementVNode("div", {
              class: "text-h6 mb-2"
            }, "Failed to load dashboard", -1)), _createElementVNode("div", _hoisted_2, _toDisplayString(error.value), 1)])]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createElementBlock("iframe", {
          key: 2,
          src: dashboardLink.value,
          class: "w-full h-full",
          frameborder: "0",
          allowtransparency: "",
          style: _normalizeStyle({
            minHeight: __props.minHeight
          })
        }, null, 12, _hoisted_3))]),
        _: 1
      });
    };
  }
};